import { SxProps, Theme } from '@mui/material';

export const textDescriptionDrawerSX: SxProps<Theme> = {
	// wordBreak: 'break-word',
	fontSize: 'var(--font-size-default)',
	letterSpacing: '0px',
	color: '#2C2C2C',
	fontWeight: 'normal',
	opacity: 1,
};

export const tabSX: SxProps<Theme> = {
	letterSpacing: '0px',
	opacity: 1,
	color: '#333333',
	fontSize: 'var(--font-size-sm)',
	fontWeight: '900',
	textTransform: 'uppercase',

	'&.Mui-selected': {
		color: '#333333',
	},
};

export const subTabSX: SxProps<Theme> = {
	letterSpacing: '0px',
	opacity: 1,
	color: '#333333',
	fontSize: 'var(--font-size-sm)',
	fontWeight: 'bold',

	'&.Mui-selected': {
		color: '#2682E7',
	},
};

export const headerTitlesRopaSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-sm)',
	fontWeight: 'bold',
	color: '#2C2C2C',
	pt: '6px',
	pb: '6px',
};
